import React from 'react';
import styles from '../css/modules/ContentPage.module.css';
import SEO from '../components/SEO';
import { FIRMA } from '../data/firma';

export default function KiedyDoTerapeuty() {
  return (
    <div className={styles.page}>
      <SEO
        title="Kiedy do terapeuty SI w Olsztynie? Objawy zaburzeń sensorycznych | Sensorini"
        description="Sprawdź objawy zaburzeń integracji sensorycznej u dzieci. Dowiedz się, kiedy potrzebna jest diagnoza SI i terapia sensoryczna w Olsztynie. Niepokojące sygnały."
        pathname="/kiedy-do-terapeuty/"
        type="article"
      />

      <header className={styles.hero}>
        <span className={`${styles.blob} ${styles.blobA}`} aria-hidden="true" />
        <span className={`${styles.blob} ${styles.blobB}`} aria-hidden="true" />
        <div className={styles.heroInner}>
          <span className={styles.eyebrow}>Kiedy do terapeuty • Olsztyn</span>
          <h1 className={styles.h1}>Kiedy udać się do terapeuty Integracji Sensorycznej w Olsztynie?</h1>
          <p className={styles.lead}>
            Niepokojące reakcje dziecka na dotyk, dźwięki lub ruch to sygnał, że warto skonsultować się z terapeutą integracji sensorycznej Olsztyn.
          </p>
        </div>
      </header>

      <div className={styles.wrap}>
        <section className={styles.section}>
          <p>
            Zastanawiasz sie czy zachowanie Twojego dziecka jest normalne? Czy jego reakcje na dotyk, dzwieki lub ruch sa odpowiednie do wieku? Integracja Sensoryczna (IS) to proces w ktorym mozg porzadkuje bodzce z otoczenia. Gdy dziala dobrze, nie zwracamy na niego uwagi. Problem pojawia sie, gdy ten proces jest zaburzony, co wplywa na codzienne funkcjonowanie. Wlasnie wtedy potrzebna moze byc konsultacja z dobrym terapeuta SI w Olsztynie.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Diagnoza SI Olsztyn - kiedy i jak?</h2>
          <p>
            Pelna, profesjonalna diagnoza integracji sensorycznej w Olsztynie jest przeznaczona dla dzieci <strong>od 4. roku życia</strong>. Nie oznacza to jednak, ze trzeba czekac z młodszymi dziecmi. U maluchow ustala się <strong>profil sensoryczny</strong>, ktory opisuje jak dziecko radzi sobie z regulacja emocji i bodzcami. Taka wczesna interwencja i konsultacja SI w Olsztynie to klucz do wsparcia dziecka na najwazniejszym etapie rozwoju.
          </p>
        </section>

        <img
          className={styles.figure}
          src="/image/kiedy-do-terapeuty.webp"
          alt="Objawy zaburzeń sensorycznych u dziecka"
          loading="lazy"
        />

        <section className={styles.section}>
          <h2>Jakie zmysły obejmują zaburzenia integracji sensorycznej?</h2>
          <p>Problemy mogą dotyczyć nie tylko pięciu podstawowych zmysłów, ale też tych ukrytych, kluczowych dla rozwoju:</p>
          <ul className={styles.chips}>
            <li>dotykowy (niechęć do metek, brudzenia się)</li>
            <li>słuchowy (nadwrażliwość na hałas)</li>
            <li>wzrokowy (problemy z koncentracją wzrokową)</li>
            <li>smakowy i węchowy (wybiórczość pokarmowa)</li>
            <li>propriocepcja (czucie głębokie, potrzeba ściskania, siłowania)</li>
            <li>przedsionkowy (równowaga, choroba lokomocyjna, potrzeba kręcenia się)</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>Czy moje dziecko może mieć problemy z SI?</h2>
          <p>
            Dysfunkcje integracji sensorycznej moga dotyczyc kazdego dziecka, zarowno rozwijajacego sie w normie intelektualnej, jak i tych z diagnozami takimi jak autyzm, ADHD, zespól Downa czy mózgowe porażenie dziecięce.
          </p>
          <p>
            O zaburzeniach SI mowimy wtedy, gdy nietypowe zachowania i reakcje realnie utrudniaja dziecku codzienne zycie, blokuja nauke, nawiązywanie relacji z rowiesnikami i wplywaja na funkcjonowanie całej rodziny. To sygnal, by szukac pomocy u terapeuty SI w Olsztynie.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Objawy zaburzeń sensorycznych - lista kontrolna dla rodzica</h2>
          <p className={styles.muted}>Zwróć uwagę, czy Twoje dziecko przejawia któreś z poniższych zachowań w sposób uporczywy:</p>
          <ul className={styles.list}>
            <li>Ma ogromna potrzebe ruchu, nie potrafi usiedziec w miejscu, ciagle sie wierci, biega, wspina.</li>
            <li>Jest wyjatkowo niezdarne, czesto sie potyka, wpada na meble, ma problemy z utrzymaniem rownowagi.</li>
            <li>Unika placów zabaw, huśtawek, karuzel, boi sie oderwac nogi od ziemi.</li>
            <li>Chodzi na palcach, omijajac pelny kontakt stopy z podlozem.</li>
            <li>Bardzo zle znosi zabiegi pielegnacyjne: mycie wlosow, czesanie, obcinanie paznokci to zawsze walka.</li>
            <li>Jest nadwrazliwe na dzwieki - zatyka uszy przy odkurzaczu, w centrum handlowym.</li>
            <li>Przeszkadzaja mu metki, szwy w ubraniach, preferuje tylko okreslone typy materialow.</li>
            <li>Unika przytulania i dotyku, albo wrecz przeciwnie - domaga sie bardzo mocnego sciskania, dociskania.</li>
            <li>Wklada do buzi niejadalne przedmioty, gryzie rekawy, zabawki.</li>
            <li>Ma duze problemy z jedzeniem, jest wybredne, przeszkadza mu konsystencja, zapach lub wyglad potraw.</li>
            <li>Ma trudnosci z nauka nowych czynnosci ruchowych, jak jazda na rowerze, plywanie, łapanie piłki.</li>
            <li>Wydaje się być nieświadome bólu, zimna czy gorąca, nie reaguje na skaleczenia.</li>
            <li>Ma problemy z koncentracja uwagi, latwo sie rozprasza, ma trudnosci w szkole.</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>Co robić, gdy podejrzewasz zaburzenia SI?</h2>
          <p>
            Jesli wiele punktow z powyzszej listy pasuje do Twojego dziecka, nie ignoruj tego. Najlepszym krokiem bedzie <strong>konsultacja z terapeutą SI w Olsztynie</strong>. Podczas spotkania bede mogla ocenic sytuacje, przeprowadzic wstepna obserwacje i zaproponowac dalsze kroki, np. pelna diagnoze sensoryczna.
          </p>
          <p className={styles.callout}>
            Wczesna diagnoza i odpowiednio dobrana terapia sensoryczna w Olsztynie moga zdzialac cuda. Dzieki zabawie w specjalistycznie wyposazonej sali, mozg dziecka uczy sie prawidlowo przetwarzac i integrowac bodzce. To realnie poprawia funkcjonowanie dziecka i jakosc zycia całej rodziny. Nie czekaj, zadzialaj juz dzis.
          </p>
        </section>
      </div>

      <section className={styles.ctaBand}>
        <div className={styles.ctaInner}>
          <h2>Podejrzewasz zaburzenia SI u dziecka?</h2>
          <p>Umów diagnozę integracji sensorycznej w Olsztynie i rozwiej wątpliwości.</p>
          <div className={styles.ctaBtns}>
            <a href="/diagnoza-sensoryczna-olsztyn/" className={styles.btnPrimary} data-cta="booking" data-cta-location="final">Umów diagnozę</a>
            <a href={`tel:${FIRMA.telefonE164}`} className={styles.btnGhost}>Zadzwoń: {FIRMA.telefon}</a>
          </div>
        </div>
      </section>
    </div>
  );
}
